<template lang="pug">
	
	.program
		

		.background-image
			img(src="assets/images/joey-rounded-office.jpg").image-1
			img(src="assets/images/joey-black-house.jpg").image-2
			.layer(ref='layer')
		
		.interview
			img(src="assets/images/program-paper.png").bg-paper

			.interview-content
				h2.title(v-html="translate('program.title')")
				
				.question-answer(v-for="trad in translate('program.questions')")
					p.question {{trad.question}}
					p.answer {{trad.answer}}

		.credits-layer
			.credits-layer-content
				h3(ref='creditsTitle') Crédits
				ul(ref='creditsItems')
					li 
						a(href='https://www.instagram.com/ouilyame_shoesup/' target="_blank") Creative Director : <span>William Roden</span>
					li 
						a(href='https://www.instagram.com/flow_shoesup/' target="_blank") Digital Art Director : <span>Floriane Raux</span>
					li 
						a(href='https://www.instagram.com/melow_r_/' target="_blank") Editorial Manager : <span>Mélodie Raymond</span>
					li 
						a(href='https://www.instagram.com/zergueii/' target="_blank") Creative Developer : <span>Serge Wsevolojsky</span>
					li 
						a(href='https://www.instagram.com/banrocky/' target="_blank") Photographer & Retoucher : <span>Richard Banroques</span>
					li 
						a(href='https://www.instagram.com/laurawaltersstylist/' target="_blank") Stylist : <span>Laura Walters</span>
			
</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scrollable from '~abstracts/scrollable'
	import Background from '../../components/background.vue'
	import Globals from '~utils/Globals.js'

  @Component({
		name: 'Racism',
		components: { Background }
	})

	class Racism extends Scrollable {

		mounted () {
			super.mounted()

			this._dom()
		}

		init () {
			super.init()

			this.isResized = false

		}

		_bind () {
			super._bind()
		}

		_dom () {
			this.$bg = this.$el.querySelector('.background-image')
			this.$bgImg1 = this.$bg.querySelector('.image-1')
		}

		raf(y) {
			super.raf(y)
		}

		initTimeline () {
			super.initTimeline()
			
			const hw_ratio = (window.innerHeight + window.innerHeight * .2) / this.bounds.height
			const appearRatio = window.innerHeight* .5 / this.bounds.height

			this.tlAppear
				.fromTo(this.$refs.layer,.6,{opacity:0},{opacity: .7},0)
				.fromTo(this.$refs.creditsTitle,.6,{y:40,opacity:0},{y:0,opacity:1},0)
				.staggerFromTo(this.$refs.creditsItems.children,.6,{y:40,opacity:0},{y:0,opacity:1},.1,.05)
				.staggerFromTo(this.$refs.creditsItems.querySelectorAll('span'),.6,{y:10,opacity:0},{y:0,opacity:1},.1,.1)
			
			this.tl.fromTo(this.$bg,1,{y:0},{y:(this.bounds.height - window.innerHeight), ease:Power0.easeNone},0)
			this.tl.fromTo(this.$bgImg1,.1,{opacity:1},{opacity:0, ease:Power0.easeNone},(1-hw_ratio))
			this.tl.add(()=>{
				const p = this.tlAppear.progress()

				if(this.scroller.direction === 1 || this.isResized == false) {
					this.tlAppear.play(p)
				} else {
					this.tlAppear.reverse(p)
				}

				this.isResized = true
			},1 - appearRatio)

		}

		_resize () {
			super._resize()

			this.isResized = false

			this.boundsAnim = {
				top: this.bounds.top,
				bottom: this.bounds.top + this.bounds.height - window.innerHeight
			}


			this.initTimeline ()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}

	}

	export default Racism

</script>


<style lang="stylus">
	
	@import '../../theme/utils'
	@import '../../theme/variables'
	
	.program
		width 100%
		min-height 100vh
		background #0f0d37
		position relative
		padding-bottom 10%
		padding-top 90vh
		padding-bottom 90vh

		.layer
			background-color #000
			position absolute
			left 0
			bottom 0
			height 100vh
			width 100%
			z-index 30
			opacity 0

		.interview
			position relative
			z-index 50
			max-width 740px
			margin auto

			+break(minlg)
				max-width 45%

			img.bg-paper
				width 100%

			.interview-content
				position absolute
				top 0
				left 0
				padding 5vw

				.title
					text-align center
					font-size 50px
					text-transform uppercase
					letter-spacing .15em
					font-family $FONT_SECONDARY
					font-weight 700

					span:first-child
						color $COLOR_BLUE

					span:last-child
						color $COLOR_RED

				.question-answer
					margin-top 24px
					
					p
						font-size em(15px)
						line-height em(24px,15px)
						color $COLOR_BLUE

						&.question
							font-family $FONT_PRIMARY
							font-weight 700

						&.answer
							font-family $FONT_THIRDLY

		.background
			z-index 30

		.background-image
			position absolute
			top 0
			left 0
			height 100vh
			width 100%
			z-index 20

			.image-1
				z-index 30

			.image-2
				z-index 20

			img
				width 100%
				position absolute
				top 0
				left 0
				height 100%
				object-fit cover

		.credits-layer
			position absolute
			z-index 70
			bottom 0
			left 0
			height 100vh
			width 100%
			display flex
			align-items center
			justify-content center

			.credits-layer-content
				color #fff
				position relative
				z-index 50
				width 100%
				max-width 760px
				padding 0 20px

				+break(minlg)
					max-width 900px

				+break(minxlg)
					max-width 1200px

				h3
					font-size em(42px)
					margin-bottom 32px

				ul
					li
						opacity 0
						transform translateY(40px)
						margin-bottom 24px	
						a
							font-size em(24px)
							text-decoration none
							color #fff

							span
								font-weight 900
								letter-spacing 0.05em
								opacity 0
								transform translateY(20px)
								display inline-block

		
	

</style>


// WEBPACK FOOTER //
// program.vue?68f39bc8